export function getImageMainColor(imgSrc) {
  return new Promise((resolve, reject) => {
    let canvas = document.createElement('canvas') // 创建canvas对象
    let img = new Image()
    let ctx = null
    let rgb = { // 图片颜色对象
      r: 0,
      g: 0,
      b: 0
    }
    let i = -4
    let count = 0
    img.onload = () => {
      // 设置canvas尺寸
      canvas.width = img.width
      canvas.height = img.height
      ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0 , 0, img.width, img.height )
      let data = ctx.getImageData(0, 0, img.width, img.height).data
      let r = 0,
          g = 0,
          b = 0;
      while((i+=20) < data.length) {
        count = count + 1
        r += data[i]
        g += data[i + 1]
        b += data[i + 2]
      }
      rgb.r = Math.round(r / count)
      rgb.g = Math.round(g / count)
      rgb.b = Math.round(b / count)
      resolve(rgb)
    }
    img.onerror = error => {
      reject(error)
    }
    img.crossOrigin="anonymous"
    img.src = imgSrc
  })
}
